import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Button } from 'antd';
import path from './images/403.png';

export default class Error403 extends React.Component {
	render() {
		return (
			<div className="exception">
				<div className="imgBlock">
					<div className="imgEle" style={{ backgroundImage: `url(${path})` }}></div>

				</div>

				<div className="content">
					<h1>403</h1>
					<div className="desc">抱歉，你无权访问该页面</div>
					<div className="action">
						{/*<Button type="primary">返回首页</Button>*/}
					</div>
				</div>

			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./containers/Exception/403/index.js